import React, { useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { deleteBreachCategory } from '../../../../../slices/breachCategory/thunk';
import { setRequireCloseModal } from '../../../../../slices/breachCategory/reducer';
import { Icons } from '../../../../../utils/Icons';

const DeleteBreachCategoryModal = ({
	dataBreachCategory,
	isOpen,
	handlerToggleModal,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();

	const selectorBreachCategory = createSelector(
		state => state.BreachCategory,
		data => ({
			isDeleting: data.isDeleting,
			requireCloseModal: data.requireCloseModal,
		})
	);
	const { isDeleting, requireCloseModal } = useSelector(selectorBreachCategory);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	function handlerDelete() {
		dispatch(deleteBreachCategory(dataBreachCategory));
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar una categoría de incumplimiento!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en confirmar.
						</p>
						<p className='small'>
							Categoría de Incumplimiento:{' '}
							{dataBreachCategory !== null ? dataBreachCategory.name : ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button
								className='btn-danger btn-label'
								onClick={() => handlerToggleModal()}
							>
								<i className='icon-x label-icon'></i> Cancelar
							</Button>
							<button
								className='btn btn-label btn-primary'
								onClick={() => handlerDelete()}
								disabled={isDeleting}
							>
								{isDeleting ? (
									<i className='label-icon'>
										<Spinner size='sm' />
									</i>
								) : (
									<i className={`${Icons.check2} label-icon`}></i>
								)}{' '}
								Confirmar
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteBreachCategoryModal;
